<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.85 7.5H3.15A1.16 1.16 0 012 6.35v-3.2A1.16 1.16 0 013.15 2h17.7A1.16 1.16 0 0122 3.15v3.2a1.16 1.16 0 01-1.15 1.15zM4 5.5h16V4H4zM20.85 14.75H3.15A1.16 1.16 0 012 13.6v-3.2a1.16 1.16 0 011.15-1.15h17.7A1.16 1.16 0 0122 10.4v3.2a1.16 1.16 0 01-1.15 1.15zM4 12.75h16v-1.5H4zM20.85 22H3.15A1.16 1.16 0 012 20.85v-3.2a1.16 1.16 0 011.15-1.15h17.7A1.16 1.16 0 0122 17.65v3.2A1.16 1.16 0 0120.85 22zM4 20h16v-1.5H4z"/></svg>